// 直播间
const live = () => import('@/pages/live/live.vue');
const threeScreenLive = () => import('@/pages/live/threeScreenLive.vue');
export default [
  {
    path: '/live',
    name: 'live',
    component: live,
    meta: {
      title: '直播',
      requireAuth: true,
    },
  },
  {
    path: '/threeScreenLive',
    name: 'threeScreenLive',
    component: threeScreenLive,
    meta: {
      title: '直播',
      requireAuth: true,
    },
  },
];
